var React = require('react');

function ChevronRightGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.889818 0.287054L-2.79798e-07 1.31185L2.42606 3.98206L0.0529754 6.71138L0.964323 7.71289L4.22729 3.95825L0.889818 0.287054Z","fill":"#474747"}));
}

ChevronRightGrey.defaultProps = {"width":"5","height":"8","viewBox":"0 0 5 8","fill":"none"};

module.exports = ChevronRightGrey;

ChevronRightGrey.default = ChevronRightGrey;
